export default "__VITE_ASSET__DVmaZfCs__"